import { Box, GridLegacy as Grid } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { AsyncContent } from '~/components/AsyncContent';
import { RequireReduxData } from '~/components/RequireReduxData';
import { useResetSelectedEmployeeId } from '~/components/SelectedEmployee';
import { LeftSideMenu } from '~/features/Sidebars/LeftSideMenu';
import { allPortalDataDispatchReduxFetches } from '~/hooks/initializeData';
import { useVisible } from '~/hooks/useVisible';
import { WorkspaceToolbar } from '~/scenes/MyWorkspace/components/WorkspaceToolbar';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';

import { ManageWorkspaceLayouts } from './components/ManageWorkspaceLayouts';
import { WorkspaceInitializationProvider } from './context';
import { useMyWorkspace } from './useMyWorkspace';
import { useSxStyles } from './useStyles';

export const MyWorkspace: React.FC = () => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  useResetSelectedEmployeeId();

  const {
    isVisible: isDrawerOpened,
    show: openDrawer,
    hide: closeDrawer,
  } = useVisible(true);

  const { isLoading, failedToLoad } = useMyWorkspace();

  return (
    <WorkspaceInitializationProvider>
      <AsyncContent
        isLoading={isLoading}
        failedToLoad={failedToLoad}
        failedToLoadMessage={t('failedToLoadUserSettings')}
        customSxStyles={{ root: sxStyles.root }}
      >
        <Box sx={sxStyles.content}>
          <Box sx={sxStyles.sidebar}>
            <LeftSideMenu
              open={isDrawerOpened}
              handleDrawerOpen={openDrawer}
              handleDrawerClose={closeDrawer}
              routerLink={true}
            />
          </Box>
          <RequireReduxData
            required={allPortalDataDispatchReduxFetches}
            renderLoading={(percentage) => (
              <LoadingView>{percentage}</LoadingView>
            )}
          >
            <Box
              sx={{
                ...sxStyles.workspaceLayout,
                ...(isDrawerOpened
                  ? sxStyles.marginOpen
                  : sxStyles.marginClose),
              }}
            >
              <WorkspaceToolbar />
              <Box sx={sxStyles.widgets}>
                <Grid container direction="column">
                  <Grid item xs={10}>
                    <ManageWorkspaceLayouts />
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </RequireReduxData>
        </Box>
      </AsyncContent>
    </WorkspaceInitializationProvider>
  );
};
